import { _ } from "vue-underscore";
export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getChildrenResolutionsOrdered: state => parentResolutionId => {
      var childrenResolutions = Object.values(state.data).filter(item => {
        return item.parent_resolution_id == parentResolutionId;
      });
      return _.sortBy(childrenResolutions, item => {
        return item.position;
      });
    },
    getMeetingResolutionsForMeetingStart: (state, getters, rootState, rootGetters) => meetingId => {
      var meetingResolutions = Object.values(state.data).filter(item => {
        return item.meeting_id == meetingId;
      });
      meetingResolutions = _.sortBy(meetingResolutions, item => {
        return item.position;
      });
      return meetingResolutions.map(mr => {
        return {
          ...mr,
          children_resolutions: getters.getChildrenResolutionsOrdered(mr.id),
        };
      });
    },
  },
};
